const valoresBooleanosAtivos = [true, 1, "1", "true", "ativo", "ativa"];

const integracaoEstaAtiva = (valor) =>
  valoresBooleanosAtivos.includes(
    typeof valor === "string" ? valor.trim().toLowerCase() : valor
  );

export const isSicoobApiAtiva = (conta = {}) => {
  const codigoBanco = String(
    conta?.banco?.code ??
      conta?.banco ??
      conta?.codigo_banco ??
      conta?.banco_zoop?.code ??
      ""
  ).replace(/^0+/, "");

  const nomesBanco = [
    conta?.nome,
    conta?.banco?.name,
    conta?.banco_zoop?.name,
    conta?.descricao,
  ]
    .filter(Boolean)
    .join(" ")
    .toUpperCase();

  const contaEhSicoob = codigoBanco === "756" || nomesBanco.includes("SICOOB");

  return contaEhSicoob && integracaoEstaAtiva(conta?.integracao_api);
};
